import { useDispatch, useSelector } from "react-redux";
import BanIcon from "../../../../../components/icons/BanIcon";
import DeleteActionIcon from "../../../../../components/icons/DeleteActionIcon";
import SendNotification from "../../../../../components/sendNotification/SendNotification";
import { defaultProfileImage } from "../../../../../constants/defaultUserImage";
import { showConfirmationModal } from "../../../../../features/confirmationModal/ConfirmationModalSlice";
import { getLocalizedTime } from "../../../../../utils/timeZone";
import styles from "./oneUser.module.css";

const OneUser = ({
  name,
  email,
  gameIds,
  region,
  userImage,
  addedTime,
  modifiedTime,
  userId,
  banned,
}) => {
  const { timeZone } = useSelector((state) => state.timeZone);
  const localizedAddedTime = getLocalizedTime(addedTime, timeZone);
  const localizedModifiedTime = getLocalizedTime(modifiedTime, timeZone);
  const regionName =
    typeof region === "string" ? region : region?.name || region?.region || "-";
  const gamesCount = Array.isArray(gameIds) ? gameIds.length : 0;
  const userImageSrc =
    (typeof userImage === "string" ? userImage : userImage?.path) ||
    defaultProfileImage;

  const formatDateTime = (date) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
      return "-";
    }

    return date.toLocaleString();
  };

  const dispatch = useDispatch();

  const handleDeleteUser = () => {
    dispatch(
      showConfirmationModal({
        message: "هل انت متاكد من حذف اللاعب ؟",
        data: userId,
        actionType: "deleteUser",
      }),
    );
  };

  const handleBanUser = () => {
    dispatch(
      showConfirmationModal({
        message: banned
          ? "هل انت متأكد من ازالة الحظر ؟"
          : "هل انت متأكد من حظر اللاعب ؟",
        data: {
          userId,
          userData: {
            banned: !banned,
          },
        },
        actionType: "updateUser",
      }),
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div className={styles.identityRow}>
          <div className={styles.avatar}>
            <img src={userImageSrc} alt={name || "user"} />
          </div>
          <div className={styles.identityText}>
            <h3 className={styles.userName}>{name || "-"}</h3>
            <p className={styles.userEmail}>{email || "-"}</p>
          </div>
        </div>
        <div className={styles.summaryGrid}>
          <div className={styles.summaryCard}>
            <span className={styles.summaryLabel}>المنطقة</span>
            <span className={styles.summaryValue}>{regionName || "-"}</span>
          </div>
          <div className={styles.summaryCard}>
            <span className={styles.summaryLabel}>الحالة</span>
            <span
              className={
                banned
                  ? `${styles.summaryValue} ${styles.statusDanger}`
                  : `${styles.summaryValue} ${styles.statusSuccess}`
              }
            >
              {banned ? "محظور" : "نشط"}
            </span>
          </div>
          <div className={styles.summaryCard}>
            <span className={styles.summaryLabel}>حسابات الألعاب</span>
            <span className={styles.summaryValue}>{gamesCount}</span>
          </div>
        </div>
        {gamesCount > 0 && (
          <div className={styles.gamesSection}>
            <span className={styles.sectionLabel}>تفاصيل الألعاب</span>
            <div className={styles.gamesGrid}>
              {gameIds.map((gameId, index) => {
                return (
                  <div
                    className={styles.gameCard}
                    key={`${gameId?.gameName || "game"}-${gameId?.inGameId || index}`}
                  >
                    <span className={styles.gameMeta}>
                      اللعبة: {gameId?.gameName || "-"}
                    </span>
                    <span className={styles.gameMeta}>
                      الاسم: {gameId?.inGameName || "-"}
                    </span>
                    <span className={styles.gameMeta}>
                      الايدي: {gameId?.inGameId || "-"}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        <div className={styles.metaGrid}>
          <div className={styles.metaCard}>
            <span className={styles.metaLabel}>تمت الإضافة</span>
            <span className={styles.metaValue}>
              {formatDateTime(localizedAddedTime)}
            </span>
          </div>
          <div className={styles.metaCard}>
            <span className={styles.metaLabel}>آخر تعديل</span>
            <span className={styles.metaValue}>
              {formatDateTime(localizedModifiedTime)}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.optionsWrapper}>
        <div className={styles.notificationAction}>
          <SendNotification
            targetType={"user"}
            type={"general"}
            targetId={userId}
          />
        </div>
        <button
          type="button"
          className={`${styles.actionButton} ${styles.moderationAction}`}
          onClick={handleBanUser}
        >
          <BanIcon className={styles.svgIcon} />
          <span>
            {banned ? "ازالة الحظر" : "حظر اللاعب"}
          </span>
        </button>
        <button
          type="button"
          className={`${styles.actionButton} ${styles.deleteAction}`}
          onClick={handleDeleteUser}
        >
          <DeleteActionIcon className={styles.svgIcon} />
          <span>حذف اللاعب</span>
        </button>
      </div>
    </div>
  );
};

export default OneUser;
